import { render, staticRenderFns } from "./d-sticky-menu-save-to-library.vue?vue&type=template&id=139040d0&scoped=true&"
import script from "./d-sticky-menu-save-to-library.vue?vue&type=script&lang=js&"
export * from "./d-sticky-menu-save-to-library.vue?vue&type=script&lang=js&"
import style0 from "./d-sticky-menu-save-to-library.vue?vue&type=style&index=0&id=139040d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139040d0",
  null
  
)

export default component.exports